// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media only screen and (max-width:990px){.hiddenIn990[data-v-c8a0ea5e]{display:none!important}}", ""]);
// Exports
module.exports = exports;
